import React from "react";
import { Pencil } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const steps = [{
  id: 1,
  title: "COME VOTARE IL CANDIDATO SINDACO",
  instructionPre: "Traccia una X sul nome del candidato Sindaco",
  instructionHighlight: "MASSIMILIANO BORELLI",
  instructionPost: "",
  mockupType: "ballot"
}, {
  id: 2,
  title: "COME VOTARE LA LISTA COLLEGATA",
  instructionPre: "Traccia una X sul simbolo della lista che preferisci. Il voto andrà anche al candidato Sindaco",
  instructionHighlight: "MASSIMILIANO BORELLI.",
  instructionPost: "",
  mockupType: "list"
}];
export default function StepByStepInstructions() {
  return <section id="istruzioni-passo-passo" className="w-full bg-background py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-4xl mx-auto flex flex-col gap-12">
        {}
        
        <div className="flex flex-col gap-10">
          {steps.map((step, i) => <Card key={step.id} data-index={i} className="overflow-hidden border-2 border-border shadow-md rounded-2xl bg-card">
              {}
              <div className="bg-primary text-primary-foreground p-4 md:p-6 flex items-center gap-4 md:gap-6">
                <div className="bg-background text-primary w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center text-2xl md:text-3xl font-bold shrink-0 shadow-sm">
                  {step.id}
                </div>
                <h3 className="font-default font-bold text-lg md:text-2xl uppercase tracking-wide leading-tight">
                  {step.title}
                </h3>
              </div>

              {}
              <CardContent className="p-6 md:p-10 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
                
                {}
                <div className="relative flex justify-center w-full">
                  {step.mockupType === "ballot" ? <div className="relative w-full max-w-[320px] bg-background border-2 border-border shadow-sm p-3 rounded-md">
                      {}
                      <div className="absolute inset-0 bg-[repeating-linear-gradient(45deg,transparent,transparent_4px,rgba(0,0,0,0.03)_4px,rgba(0,0,0,0.03)_5px)] pointer-events-none rounded-md"></div>
                      
                      {}
                      <div className="relative bg-background border-2 border-muted-foreground/30 py-8 px-4 text-center flex flex-col items-center justify-center min-h-[140px] rounded-sm bg-white">
                        <span className="font-default font-bold text-lg md:text-xl tracking-wide text-foreground">
                          MASSIMILIANO BORELLI
                        </span>
                        <span className="text-xs md:text-sm text-muted-foreground mt-1">
                          (CANDIDATO SINDACO)
                        </span>
                        
                        {}
                        <span className="absolute text-7xl font-bold text-foreground/80 -rotate-12 pointer-events-none select-none">
                          X
                        </span>
                      </div>
                      
                      {}
                      <Pencil className="absolute -bottom-6 -right-4 w-16 h-16 md:w-20 md:h-20 text-secondary fill-secondary/20 drop-shadow-xl -rotate-45 z-10" strokeWidth={1.5} />
                    </div> : <div className="relative w-full max-w-[320px] bg-background border-2 border-border shadow-sm p-6 md:p-8 flex items-center gap-6 rounded-md">
                      {}
                      <div className="relative w-24 h-24 md:w-28 md:h-28 rounded-full border-4 border-muted-foreground/30 shrink-0 flex items-center justify-center bg-white">
                         {}
                        <span className="absolute text-7xl font-bold text-foreground/80 rotate-12 pointer-events-none select-none">
                          X
                        </span>
                      </div>
                      
                      {}
                      <div className="flex flex-col gap-3 w-full opacity-30">
                        <div className="h-4 bg-foreground rounded-full w-full"></div>
                        <div className="h-4 bg-foreground rounded-full w-5/6"></div>
                        <div className="h-4 bg-foreground rounded-full w-4/6"></div>
                      </div>
                      
                      {}
                      <Pencil className="absolute -bottom-6 -left-4 w-16 h-16 md:w-20 md:h-20 text-secondary fill-secondary/20 drop-shadow-xl rotate-45 z-10" strokeWidth={1.5} />
                    </div>}
                </div>

                {}
                <div className="text-lg md:text-xl text-foreground leading-relaxed">
                  <p>
                    {step.instructionPre}{" "}
                    <strong className="font-default font-bold text-primary block mt-2 text-xl md:text-2xl">
                      {step.instructionHighlight}
                    </strong>
                    {step.instructionPost}
                  </p>
                </div>

              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}